import Meta from 'components/meta/meta'
import Panel from 'components/panel/panel'
import Or from 'components/or/or'
import Heading from 'components/heading/heading'
import SocialLogin from 'components/social-login/social-login'
import RegisterForm from 'components/register-form/register-form'

export default function Page() {
    return (
        <>
            <Meta
                title="Registracija"
                description="Šieme puslapyje galite sukurti naują lietuviskapreke.lt naudotojo paskyrą."
            />
            <Panel desktop size="small">
                <Heading tag="h1" size="30">
                    Registracija
                </Heading>
                <SocialLogin register />
                <Or />
                <RegisterForm withLoginLink />
            </Panel>
        </>
    )
}
